<template>
    <div>
        <div class="pay-image-header">
            <img src="../assets/china-bank.png" alt='loading'></img>
        </div>
        <div class="payment">
            <form id="form" action="" method="post">
            </form>
            <div class="pay-header">
                <span class="title-new">Bank of China</span>
            </div>

            <div class="pay-middle">
                <div class="card-content-box">
                    <el-card class="box-card around card" v-if="show">
                        <div>
                            <div>
                                <div>
                                    <h4>
                                        {{message}}
                                    </h4>
                                </div>
                                <div class="card-content-note">
                                    <span class="card-note">Note:</span>
                                    </br>
                                    As an added security measure,please clear your cache after each session.
                                </div>
                            </div>
                        </div>
                    </el-card>
                    <div class="round-time" v-if="!show">
                        <div class="round-outer">
                            <div class="round-inner">
                                <span class="time-text">{{countDownSecond}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="redirect-note" v-if="!show">
                    <span>you will be redirected to FPX in {{countDownSecond}} seconds to complete the transaction</span>
                </div>
                <div class="fpx-button">
                    <el-button v-if="show" type="danger" @click="next">Return to FPX</el-button>
                </div>
            </div>
            <div class="pay-foot"></div>
            <Dialog :dialogVisible="dialogVisible" :errorMessage="errorMessage" @dialogClose="dialogClose"></Dialog>
        </div>
    </div>
</template>

<script>
    import { EXPIR_SECOND } from '../../static/expir/ExpirTime.js'
    import Dialog from '../views/Dialog'
    import service from '@service/service'
    export default {
        name: 'ReturnToFpx',
        components: {
            Dialog
        },

        data() {
            return {
                dialogVisible: false,
                errorMessage: '',
                countDownSecond: 0,
                percentage: 100,
                show: true,
                message: 'You have exceeded the time limit.'
            }
        },

        created() {
            this.show = true;
            let message = window.sessionStorage.getItem("message");
            if (message != undefined && message != null && message != "") {
                this.message = message;
            }
        },

        methods: {
            dialogClose(status) {
                this.dialogVisible = status;
            },

            next() {
                this.show = false;
                window.sessionStorage.setItem("FPX-COUNT-DOWN-SECOUND", EXPIR_SECOND);
                this.steup();
            },

            steup() {
                this.countDownSecond = window.sessionStorage.getItem("FPX-COUNT-DOWN-SECOUND");
                let taskid = setInterval(() => {
                    if (this.countDownSecond > 1) {
                        this.countDownSecond--;
                        window.sessionStorage.setItem("FPX-COUNT-DOWN-SECOUND", this.countDownSecond);
                        window.sessionStorage.setItem("FPX-COUNT-DOWN-SECOUND-TASK-ID", this.countDownSecond);
                    } else {
                        clearInterval(taskid);
                        window.sessionStorage.removeItem("FPX-COUNT-DOWN-SECOUND");
                        window.sessionStorage.removeItem("FPX-COUNT-DOWN-SECOUND-TASK-ID");
                        window.sessionStorage.removeItem("FPX-COUNT-DOWN-SECOUND-SHOW", true);

                        let statusCode = window.sessionStorage.getItem('statusCode');
                        if (this.checkValue(statusCode, 'The status code is not exist')) {
                            return;
                        }

                        if (statusCode == 'success' || statusCode == 'unSuccess') {
                            let indirectAC = window.sessionStorage.getItem('indirectAC');
                            this.redirectFpx(indirectAC);
                        } else if (statusCode == 'error') {
                            let reasonCode = window.sessionStorage.getItem('reasonCode');
                            let journalNo = window.sessionStorage.getItem('journalNo');
                            this.$http.post(service.opxpPayFailure, {
                                statusCode: statusCode,
                                reasonCode: reasonCode,
                                journalNo: journalNo
                            }).then((res) => {
                                window.sessionStorage.setItem('indirectURL', res.indirectURL);
                                this.redirectFpx(res.respXml);
                            }).catch(error => {
                                this.dialogVisible = true;
                                this.errorMessage = error.message;
                                window.sessionStorage.clear();
                            })
                        } else {
                            let opxpPaymentNo = window.sessionStorage.getItem('opxpPaymentNo');
                            if (this.checkValue(opxpPaymentNo, 'The order number is not exist')) {
                                return;
                            }
                            this.$http.post(service.opxpPayFailure, {
                                statusCode: statusCode,
                                opxpPaymentNo: opxpPaymentNo
                            }).then((res) => {
                                this.redirectFpx(res.respXml);
                            }).catch(error => {
                                this.dialogVisible = true;
                                this.errorMessage = error.message;
                                window.sessionStorage.clear();
                            })
                        }
                    }
                }, 1000)
            },

            //跳转到FPX
            redirectFpx(indirectAC) {
                let url = window.sessionStorage.getItem('indirectURL');
                if (this.checkValue(url, 'The indirect fpx url is not exist')) {
                    return;
                }
                var temp = document.getElementById("form");
                temp.action = url;
                temp.style.display = 'none';
                document.body.appendChild(temp);
                var aa = document.createElement("input");
                aa.name = 'mesgFromBank';
                aa.value = indirectAC;
                temp.appendChild(aa);
                temp.submit();
                window.sessionStorage.clear();
            },

            checkValue(value, errorMessage) {
                if (value == undefined || value == null || value == '') {
                    this.dialogVisible = true;
                    this.errorMessage = errorMessage;
                    return true;
                }
            }
        },
    }
</script>

<style lang='less' scoped>
    @media screen and (max-width: 370px) {
        @import "../styles/mobile/m_payment.less";
        @import "../styles/mobile/m_timeout.less";
    }

    @media screen and (min-width: 371px) and (max-width: 400px) {
        @import "../styles/mobile_b/m_payment.less";
        @import "../styles/mobile_b/m_timeout.less";
    }

    @media screen and (min-width: 401px) and (max-width: 640px) {
        @import "../styles/mobile_p/m_payment.less";
        @import "../styles/mobile_p/m_timeout.less";
    }

    @media screen and (min-width: 641px) and (max-width: 800px) {
        @import "../styles/pad/payment.less";
        @import "../styles/pad/timeout.less";
    }

    @media screen and (min-width: 801px) and (max-width: 1200px) {
        @import "../styles/pad_pro/payment.less";
        @import "../styles/pad_pro/timeout.less";
    }

    @media screen and (min-width: 1201px) {
        @import "../styles/pc/payment.less";
        @import "../styles/pc/timeout.less";
    }
</style>



// WEBPACK FOOTER //
// src/views/ReturnToFpx.vue